(() => {
  const addClasses = (slider) => {
    const sliderWrapper = slider.querySelector(".popular-products__wrapper");
    const slides = slider.querySelectorAll(".popular-products__item");
    const slidesPlaceholder = slider.querySelectorAll(".popular-products__item_placeholder");

    slider.classList.add("swiper");
    if (sliderWrapper) sliderWrapper.classList.add("swiper-wrapper");

    if (slides.length > 1) {
      slides.forEach((slide) => {
        slide.classList.add("swiper-slide");
      });
    }

    if (slidesPlaceholder.length > 1) {
      slidesPlaceholder.forEach((slide) => {
        slide.classList.add("swiper-slide");
      });
    }
  };

  const removeClasses = (slider) => {
    const sliderWrapper = slider.querySelector(".popular-products__wrapper");
    const slides = slider.querySelectorAll(".popular-products__item");
    const slidesPlaceholder = slider.querySelectorAll(".popular-products__item_placeholder");

    slider.classList.remove("swiper");
    if (sliderWrapper) sliderWrapper.classList.remove("swiper-wrapper");

    if (slides.length > 0) {
      slides.forEach((slide) => {
        slide.removeAttribute("style");
        slide.classList.remove("swiper-slide");
      });
    }

    if (slidesPlaceholder.length > 0) {
      slidesPlaceholder.forEach((slide) => {
        slide.removeAttribute("style");
        slide.classList.remove("swiper-slide");
      });
    }
  };

  const initSlider = (section) => {
    const slider = section.querySelector(".swiper--products");

    if (slider) {
      addClasses(slider);
      const numberColumns = slider.dataset.columnsMobile || 1;

      const swiperConfig = {
        loop: false,
        speed: 800,
        breakpoints: {
          320: {
            slidesPerView: Number(numberColumns),
            slidesPerGroup: Number(numberColumns),
            spaceBetween: 8,
          },
          750: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 16,
          },
        },
        pagination: {
          el: slider.querySelector(".popular-products__pagination"),
          clickable: true,
          dynamicBullets: true,
          type: "custom",
          renderCustom: function (swiper, current, total) {
            let out = "";
            for (let i = 1; i < total + 1; i++) {
              if (i == current) {
                out = `${out}<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide ${i}"></span>`;
              } else {
                out = `${out}<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${i}"></span>`;
              }
            }
            return out;
          },
        },
        navigation: {
          nextEl: `#${slider.id} .swiper-button-next`,
          prevEl: `#${slider.id} .swiper-button-prev`,
        },
      };

      const desktopNumberColumns = slider.dataset.columnsDesktop;
      if (desktopNumberColumns) {
        swiperConfig.breakpoints[1200] = {
          slidesPerView: Number(desktopNumberColumns),
          slidesPerGroup: Number(desktopNumberColumns),
          spaceBetween: 16,
        };
      }

      new Swiper(slider, swiperConfig);

    }
  };

  const destroySlider = (section) => {
    const slider = section.querySelector(".swiper--products");

    if (slider) {
      removeClasses(slider);
    }
  };

  const initSection = (section) => {
    if (section && section.classList.contains("popular-products-section")) {
      const resizeObserver = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.contentRect.width > 1200) {
            const productItems = entry.target.querySelectorAll(".popular-products__item");

            productItems.forEach((item) => {
              item.addEventListener("mouseover", () => {
                productItems.forEach((otherItem) => {
                  if (otherItem !== item) {
                    otherItem.classList.add("popular-products__item--inactive");
                  }
                });
              });

              item.addEventListener("mouseout", () => {
                productItems.forEach((item) => {
                  item.classList.remove("popular-products__item--inactive");
                });
              });
            });
          }

          const slider = entry.target.querySelector(".swiper");
          if (slider) {
            if (slider.hasAttribute("data-desktop-slider")) {
              initSlider(entry.target);
            } else {
              if (entry.contentRect.width < 990) {
                initSlider(entry.target);
              } else {
                destroySlider(entry.target);
              }
            }
          }
        });
      });

      resizeObserver.observe(section);
    }
  };

  initSection(document.currentScript.parentElement);

  // const paginationObserver = new MutationObserver((mutations) => {
  //   mutations.forEach((mutation) => {
  //     if (mutation.type === "attributes" && mutation.attributeName === "class") {
  //       const target = mutation.target.querySelector(".swiper-pagination-bullet-active");
  //       if (target) {
  //         const bullets = Array.from(target.parentElement.children);
  //         const activeIndex = bullets.indexOf(target);

  //         bullets.forEach((bullet, index) => {
  //           bullet.classList.remove("swiper-pagination-bullet-prev", "swiper-pagination-bullet-next");
  //         });

  //         if (bullets[activeIndex - 1]) {
  //           bullets[activeIndex - 1].classList.add("swiper-pagination-bullet-prev");
  //         }
  //         if (bullets[activeIndex + 1]) {
  //           bullets[activeIndex + 1].classList.add("swiper-pagination-bullet-next");
  //         }
  //         if (bullets[activeIndex - 2]) {
  //           bullets[activeIndex - 2].classList.add("swiper-pagination-bullet-prev-prev");
  //         }
  //         if (bullets[activeIndex + 2]) {
  //           bullets[activeIndex + 2].classList.add("swiper-pagination-bullet-next-next");
  //         }
  //       }
  //     }
  //   });
  // });

  // const paginationElement = document.querySelector(".popular-products__pagination");
  // if (paginationElement) {
  //   const config = { attributes: true, subtree: true, attributeFilter: ["class"] };
  //   paginationObserver.observe(paginationElement, config);
  // }

  document.addEventListener("shopify:section:load", function (event) {
    initSection(event.target);
  });
})();
